<template>
	<div class="tab_view">
		<div class="topTab">
			<div class="tab_item" :style="tabStyle(index)" v-for="(item,index) in list" :key="index" @click="tabClick(index)">
				<span>{{item}}</span>
				<span v-if="tabNumArr.length"
					:class="tabNumArr[index].count > 0 ? 'tag':''">{{tabNumArr[index].count >= 0 ? tabNumArr[index].count : ''}}</span>
			</div>
		</div>
		<el-divider class="lin" />
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array
			},
			tabIndex: {
				type: Number
			}
		},
		data() {
			return {
				tabNumArr: []
			}
		},
		computed: {
			tabStyle() {
				return function(index) {
					return {
						'border-left': index == this.tabIndex ? '1px solid var(--theme-color)' : '1px solid #d8d8d8',
						'border-right': index == this.tabIndex ? '1px solid var(--theme-color)' : '1px solid #d8d8d8',
						'border-top': index == this.tabIndex ? '1px solid var(--theme-color)' : '1px solid #d8d8d8',
						'color': index == this.tabIndex ? 'var(--theme-color)' : '#9e9e9e',
					}
				}
			}
		},
		methods: {
			tabClick(index) {
				this.$emit('tabClick', index)
			},
			
			tabNumList(list) {
				this.tabNumArr = list;
			}
		}
	}
</script>

<style scoped>
	.tab_view {
		height: 40px;
		/* margin: 10px 0 0px 0; */
	}

	.topTab {
		display: flex;
		flex-direction: row;
		width: calc(100% - 40px);
		/* padding: 0 20px; */
	}

	.tab_item {
		display: flex;
		width: 120px;
		height: 40px;
		align-items: center;
		justify-content: center;
		border-radius: 10px 10px 0 0;
		font-size: 14px;
        cursor: pointer;
	}

	.tag {
		display: flex;
		align-items: center;
		justify-content: center;
		background: #EA0000;
		font-size: 12px;
		color: #fff;
		width: 18px;
		height: 18px;
		border-radius: 50%;
        margin-left: 4px;
	}

	.lin {
		margin: 0 0;
		/* background: var(--theme-color); */
	}
</style>